import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class CreateCreditCardMutation extends Mutation {
  document = gql`
    mutation createCreditCard($source: String!) {
      createCreditCard(source: $source)
    }
  `;
}
